import {Box, Heading, Stack, Tag, Text} from "@chakra-ui/react";
import React from "react";
import {PageProps} from "gatsby";
import GatsbyLink from "../../components/GatsbyLink";
import TitledPage from "../../layout/TitledPage";

export default ({data}: PageProps<GatsbyTypes.NewsPageQuery>) => <TitledPage title="News">
    {data ?
        <Stack spacing={6}>
            {
                data.allNewsPost.edges.map(edge => {
                    const {node} = edge;

                    const {id, title, excerpt, tags, slug, date, author} = node;
                    return (
                        <Box key={id}>
                            <Heading as="h2" size="lg" color="primary.800"><GatsbyLink
                                to={slug}>{title}</GatsbyLink></Heading>
                            <p>{excerpt} <GatsbyLink to={slug}>Read more</GatsbyLink></p>
                            <Box borderTopWidth={1} borderTopStyle="solid" borderTopColor="primary.100">
                                Posted: {date} by {author} |
                                Tags: {tags.map((tag) => {
                                return <Tag key={tag}>{tag}</Tag>
                            })}
                            </Box>
                        </Box>
                    )
                })
            }
        </Stack> :
        <Text as="p">No content</Text>
    }
</TitledPage>